import { getMessages } from '../../../../../../store/constants';

export const TOPBAR_STAT_DONE = getMessages().getText('top_bar.stat.done');
export const TOPBAR_STAT_OVERDUE = getMessages().getText('top_bar.stat.overdue');
export const TOPBAR_STAT_MYTASKS = getMessages().getText('top_bar.stat.mytasks');
export const TOPBAR_STAT_HINT = 'Click to activate a filter option';
